<template>
   <div>
      <div class="row" >
            <div class="col-12 col-lg-6 mb-3"></div>
            <div class="col-12 col-lg-6 mb-3 d-flex flex-row justify-content-end align-items-end" v-if="button">
                <a class="btn btn-primary" data-ripple="true" v-on:click="linkAsunto()">
                    Contenido
                </a>
            </div>
      </div>
      <div class="row">
         <div class="col-12">
            <h3>{{ $t('textProcesses.textTitleDescription') }}</h3>
            <p v-html='dataProcessTask.description'></p>
         </div>
      </div>
      <div class="row">
         <div class="col-12">
            <h3>Asunto</h3>
            <p v-html='dataProcessTask.asunto'></p>
         </div>
      </div>
      <div class="row">
         <div class="col-12">
            <h3>{{ $t('textProcesses.textTitleRules') }}</h3>
            <ul>
               <li class="mb-1" v-for="(item, index) in dataProcessTask.rules" :key="index"><a href="#" v-on:click.prevent="onViewRuleDetail(item)">{{ item.titulo }}</a></li>
            </ul>
         </div>
      </div>
      <div class="row mb-2">
         <div class="col-12">
            <h3>{{$t('textDetailRule.processes')}}</h3>
            <ejs-grid ref='grid' :dataSource='dataProcessTask.proceso' :allowPaging="true" :allowSorting="true" :pageSettings='pageSettings'>
               <e-columns>
                  <e-column field="nombre" :headerText="$t('textDetailRule.processes')" :template="processTemplate" width="120px"></e-column>
                  <e-column field="interes" :headerText="$t('textDetailRule.interest')" :template="interestTemplate" width="170px"></e-column>
               </e-columns>
            </ejs-grid>
         </div>
      </div>
      <div class="row">
         <div class="col-12">
            <h3>{{ $t('textProcesses.textTitleHistory') }}</h3>
            <ul>
               <li v-for="(item, index) in dataProcessTask.history" :key="index">
                  <b>{{ item.created_at }}: </b>
                  <span  v-html="item.descripcion"></span>
               </li>
            </ul>
         </div>
      </div>

   </div>
</template>

<script>
import axios from 'axios'
import { Page, Sort } from "@syncfusion/ej2-vue-grids";

export default {
   name: "processes-detail-process-task-rule-detail",
   props: ["data"],
   provide: {
		grid: [Sort, Page]
	},
	data () {
		return {
         button: false,
         process: false,
         pageSettings: { pageSize: 5 },
         dataProcessTask: {
            rules: [],
            history: [],
            proceso: [],
            asunto_id: '',
            description: '',
            asunto: '',
         },
         interestTemplate: function (e){
            return {
               template: Vue.component('interestTemplate', {
                  template: `<span v-bind:class="(data.interes == 1) ? 'text-info' : 'text-danger'">{{textInterest(data.interes)}}</span>`,
                  data(){
                     return {
                        data: []
                     }
                  },
                  methods: {
                     textInterest: function(interes){
                        switch (interes) {
                           case 0: return 'Responsabilidad';
                           case 1: return 'Interes';
                           default: return '';
                        }
                     }
                  },
               })
            }
         },
         processTemplate: function (e){
            return {
               template: Vue.component('processTemplate', {
                  template: `<a href="#" v-on:click.prevent="textProcess(data.id)">{{data.nombre}}</a>`,
                  data(){
                     return {
                        data: []
                     }
                  },
                  methods: {
                     textProcess: function(id){
                        this.$router.push("/procesos/detalle/" + id);
                        Vue.prototype.$eventHub.$emit('closeSidebarClick');
                     }
                  },
               })
            }
         },
      }
   },
	methods: {
		initProcessTaskRuleDetail: function() {
         axios.post('/auth/processes/getComplianceRuleDetail', {
            cumplimiento_id: this.data.cumplimiento_id ? this.data.cumplimiento_id : this.data.id
         }).then(response => {
            this.dataProcessTask.history = response.data.history;
            this.dataProcessTask.rules = response.data.normas;
            this.dataProcessTask.description = response.data.compliance.descripcion;
            this.dataProcessTask.asunto = response.data.compliance.asunto;
            this.dataProcessTask.asunto_id = response.data.compliance.asuntonormativo_id;
            this.dataProcessTask.proceso = response.data.proceso;
         });
      },
      onViewRuleDetail: function(item) {
         console.log(item);
         Vue.prototype.$eventHub.$emit('toggleSidebarClick', 'Detalle norma', 'processes-detail-process-task-rule-detail-view', item, 'mw-100');
      },
      linkAsunto: function(){
         this.$router.push('/detalle-asuntos/' + this.dataProcessTask.asunto_id);
         Vue.prototype.$eventHub.$emit('closeSidebarClick');
      }
	},
	created: function() {
    this.initProcessTaskRuleDetail();
  },
  mounted() {
     //let user = JSON.parse(localStorage.access_avatar);
      let user = this.$store.getters["moduleAvatar/avatar"];
		if(parseInt(user.perfil_id) === 8){
         this.button = true;
         this.process = true;
      }
		if(parseInt(user.perfil_id) === 9){
         this.button = true;
      }
  },
}
</script>
